function initProductGallerySlider() {
  if (!window.jQuery || !jQuery.fn.slick) return;

  const $nav = jQuery(".product-gallery--navigation");

  if (!$nav.length) return;

  const totalItems = $nav.find(".product-gallery--media-thumbnail").length;
  const screenWidth = window.innerWidth;
  const $wrapper = $nav.closest(".product-gallery");

  // Destroy if already initialized
  if ($nav.hasClass("slick-initialized")) {
    $nav.slick("unslick");
  }

  if (screenWidth < 1024 && totalItems >= 4) {
    $nav.on("init afterChange", function (event, slick, currentSlide) {
      const current = currentSlide || 0;

      const $prev = $wrapper.find(".gallery-prev");
      const $next = $wrapper.find(".gallery-next");

      // Disable prev at first
      if (current === 0) {
        $prev.prop("disabled", true);
      } else {
        $prev.prop("disabled", false);
      }

      // Disable next at last
      if (current >= slick.slideCount - slick.options.slidesToShow) {
        $next.prop("disabled", true);
      } else {
        $next.prop("disabled", false);
      }
    });

    $nav.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: false,

      prevArrow: $wrapper.find(".gallery-prev"),
      nextArrow: $wrapper.find(".gallery-next"),

      responsive: [
        { breakpoint: 768, settings: { slidesToShow: 5 } },
        { breakpoint: 640, settings: { slidesToShow: 6 } },
        { breakpoint: 540, settings: { slidesToShow: 5 } },
        { breakpoint: 440, settings: { slidesToShow: 4 } }
      ]
    });
  }
}

// SAFE INIT
document.addEventListener("DOMContentLoaded", function () {
  initProductGallerySlider();
});

// RESIZE
document.addEventListener("DOMContentLoaded", function () {
  initProductGallerySlider();
})